export default __webpack_public_path__ + "static/img-homefooter-9354a3db721ea80cb6384ad164fa9363.webp";